module.exports = __webpack_public_path__ + "static/media/Illus-Delivery_2@2x.1ef05f62.png";